import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationStore = defineStore('notification', () => {
  const toasts = ref([]);

  const addToast = ({ level, message, code = null, duration = null }) => {
    const id = Date.now() + Math.random().toString(36).substring(2, 9);
    
    // Define tempo padrão por categoria se não especificado
    let autoDuration = duration;
    if (autoDuration === null) {
      if (level === 'success') autoDuration = 3500;
      else if (level === 'info') autoDuration = 4000;
      else if (level === 'warning') autoDuration = 4500;
      else if (level === 'error') autoDuration = 5500;
      else if (level === 'critical') autoDuration = null; // Sticky
    }

    const toast = {
      id,
      level, // 'critical', 'error', 'warning', 'success', 'info'
      message,
      code,
      duration: autoDuration,
      createdAt: Date.now()
    };
    
    toasts.value.push(toast);

    if (autoDuration) {
      setTimeout(() => removeToast(id), autoDuration);
    }
  };

  const removeToast = (id) => {
    toasts.value = toasts.value.filter(t => t.id !== id);
  };

  // Helper methods for easy dispatch
  const notifyCritical = (message, code) => addToast({ level: 'critical', message, code });
  const notifyError = (message, duration = null) => addToast({ level: 'error', message, duration });
  const notifyWarning = (message, duration = null) => addToast({ level: 'warning', message, duration });
  const notifySuccess = (message, duration = null) => addToast({ level: 'success', message, duration });
  const notifyInfo = (message, duration = null) => addToast({ level: 'info', message, duration });

  return { toasts, addToast, removeToast, notifyCritical, notifyError, notifyWarning, notifySuccess, notifyInfo };
});
